import React, { useState, useRef } from 'react';
import { useDispatch } from "react-redux";
import { createcategory } from '../../ReduxToolkit/Slice/Gallery/Category';
import 'react-loading-skeleton/dist/skeleton.css';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import PageTitle from '../../components/Title/PageTitle';

function AddCategory() {
    const dispatch = useDispatch();
    const closeButtonRef = useRef(null);
    const [CategoryName, setCategoryName] = useState('');
    // create
    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            CategoryName,
        };
        dispatch(createcategory(data));
        setCategoryName('');
        closeButtonRef.current.click();
    };

    return (
        <>
            <Button
                data-bs-toggle="modal"
                data-bs-target="#exampleModalCategory"
                children={"Create"}
                icon="plus-circle-fill"
            />
            {/* model */}
            <div
                className="modal fade"
                id="exampleModalCategory"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <PageTitle className={"modal-title fs-5"} children={"Create category"} />
                            <Button
                                type="button"
                                bgColor='white'
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form action="" onSubmit={handleSubmit}>
                                <Input
                                    label="Name"
                                    type="text"
                                    placeholder="Name"
                                    value={CategoryName}
                                    required
                                    onChange={(e) => setCategoryName(e.target.value)}
                                />
                                <div className={`modal-footer`}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        ref={closeButtonRef}
                                    >
                                        Close
                                    </button>
                                    <Button type="submit" children={"Create"} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddCategory